import React, { useRef, useEffect, useState } from 'react';
import Hls from 'hls.js';

const HLSPlayer = ({ theme, onVideoReady }) => {
    const videoRef = useRef(null);
    const srcUrl = "https://strapi-prod-service-er5u.onrender.com/index.m3u8";
    
    const [videoReady, setVideoReady] = useState(false);

    useEffect(() => {
        let hls;
        const video = videoRef.current;

        if (Hls.isSupported()) {
            hls = new Hls();
            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                video.play();
                setVideoReady(true);
            });
            hls.attachMedia(video);
            hls.loadSource(srcUrl);
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            // For Safari and iOS devices
            video.src = srcUrl;
            video.addEventListener('loadedmetadata', () => {
                video.play();
                setVideoReady(true);
            });
        } else {
            console.error('This browser does not support HLS.');
        }

        return () => {
            if (hls) {
                hls.destroy();
            }
        };
    }, [srcUrl]);

    useEffect(() => {
        if (videoReady && onVideoReady) {
            onVideoReady();
        }
    }, [videoReady, onVideoReady]);

    return (
        <video
            muted
            autoPlay
            loop
            playsInline
            style={{
                opacity: videoReady ? 1 : 0,
                transition: 'opacity 1s ease-in-out, filter 0.2s ease-in-out',
                position: 'fixed',
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                top: 0,
                left: 0,
                zIndex: -1,
                pointerEvents: 'none',
                filter: theme === "light" ? 'invert(1) hue-rotate(180deg) brightness(96%)' : 'none',
            }}
            ref={videoRef}>
            Your browser does not support HTML5 video.
        </video>
    );
};

export default HLSPlayer;
